import { DbFolder } from '~src/types/db';
import { FolderStructureEntry } from '~src/utils/downloader';
import { getFolderChildren, getParentsIds } from '~src/utils/tree';

/** Construct a list with all tree children, attaching a path */
export const buildFolderWithPathStructure = (
  /** root folder */
  folder: DbFolder,
  /** list with all folders */
  allFolders: DbFolder[]
): FolderStructureEntry[] => {
  const children = getFolderChildren(allFolders, folder);
  /** structure includes root folder and its children */
  const folders = [folder, ...children];

  const structure: FolderStructureEntry[] = folders.map((dbFolder) => {
    const parentIds = getParentsIds(folders, String(dbFolder.id));
    let path = '';

    if (parentIds.length) {
      // build path using folder parents
      path =
        parentIds
          .map(
            (idString) => folders.find((v) => String(v.id) === idString)?.name
          )
          .join('/') +
        '/' +
        dbFolder.name;
    } else {
      // for root folder
      path = folder.name;
    }

    return { dbFolder, id: dbFolder.id, path };
  });

  return structure;
};
